import React from 'react';
import { COLORS, FlexView, Row } from '@cuemath/comps';
import styled from 'styled-components';
import { Text } from '@cuemath/web-comps';
import { useHistory } from 'react-router-dom';
import Plus from 'img/plus-pattern.svg';
import { trackEvent } from 'modules/analytics';
import { EVENT_TYPE } from 'constants/logger';

const Root = styled(Row)`
  width: 170px;
  height: 112px;
  border: 1px solid ${COLORS.GRAY_LIGHT};
  border-radius: 0 8px 8px 0;
  border-left: none;
  cursor: pointer;
  padding: 16px 12px 14px;
  flex-direction: column;
`;

const Lable = styled(Text)`
  margin-top: 8px;
  line-height: 20px;
`;

const Temp = styled(FlexView)`
  width: 8px;
  border-radius: 8px 0 0 8px;
  background-color: ${COLORS.COLA};
  background-image: url(${Plus});
`;

function HomeScreenBox(props) {
  const { label, icon, link } = props;
  const history = useHistory();

  function routeTo() {
    if (link) {
      trackEvent(EVENT_TYPE.HOME_SCREEN_CLICK, {
        label,
        link,
      });
      history.push(link);
    }
  }

  return (
    <Row>
      <Temp />
      <Root alignItems="flex-start" onClick={routeTo} flexDirection="column">
        {icon ? <img width="32" height="32" src={icon} alt="" /> : null}
        <Lable variant="body1Regular">{label}</Lable>
      </Root>
    </Row>
  );
}

export default HomeScreenBox;
